import { CommentActionType } from "../MedicalRequest/Enum/CommentActionType";

class Comment {
    public Id: string;
    public Value: string;
    public CreateDate: Date;
    public EmployeeId: string;
    public EMRTemplateId: string;
    public MedicalRequestId: string;
    public ActionResultLookupId?: string;
    public ActionType?: CommentActionType;
}

export { Comment };
